export default __webpack_public_path__ + "static/media/plain-sticker-R.d6e805e3.png";